import { Anchor, Group, Stack, Text, useMantineTheme } from "@mantine/core"
import { IconQrcode } from "@tabler/icons-react"
import { Button, CopyButtonWithoutTitle } from "@tfg/ui"
import QRCode from "qrcode"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { publicAgecSearchPath } from "~/pages/Brand/Products/List/constants"

interface SearchEngineBlockProps {
  displaySetting:
    | OrganizationsResponses.Organization["settings"]["displaySettings"][number]
    | null
  style?: Record<string, any>
}

export const SearchEngineBlock = ({
  displaySetting,
  style,
}: SearchEngineBlockProps) => {
  const { t } = useTranslation("communicationStudio")
  const theme = useMantineTheme()

  const searchEngineURL =
    displaySetting &&
    `${document.location.origin}/${publicAgecSearchPath}/${displaySetting.slug}`
  const [qrCodeImg, setQrCodeImg] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!searchEngineURL) return

    QRCode.toDataURL(searchEngineURL, { width: 500 })
      .then((url) => {
        setQrCodeImg(url)
      })
      .catch((error) => {
        console.error("QR code generation failed:", error)
        setQrCodeImg(undefined)
      })
  }, [searchEngineURL])

  return (
    <Stack style={style} gap="xs">
      <Group justify="space-between" wrap="nowrap" gap="xl" h="fit-content">
        <Group>
          <Text fw={500} c={theme.black}>
            {t("tabs.general.communicationMaterials.searchEngine.mainURL")}
          </Text>
          {searchEngineURL && (
            <Anchor
              href={searchEngineURL}
              c={theme.black}
              underline="always"
              fz="xs"
            >
              {searchEngineURL}
            </Anchor>
          )}
        </Group>
        {searchEngineURL ? (
          <>
            <CopyButtonWithoutTitle
              copyableText={searchEngineURL}
              variant="secondary"
              size="compact-md"
              p={4}
            />
          </>
        ) : (
          t("tabs.general.communicationMaterials.searchEngine.deactivated")
        )}
      </Group>

      <Group justify="space-between" h="fit-content">
        <Text fw={500} c={theme.black}>
          {t(
            "tabs.general.communicationMaterials.searchEngine.printableQRCode"
          )}
        </Text>
        {displaySetting ? (
          <Button
            component="a"
            variant="secondary"
            download="qrCode.png"
            href={qrCodeImg}
            h="fit-content"
            p={4}
          >
            <IconQrcode width={20} height={20} stroke={1.5} />
          </Button>
        ) : (
          t("tabs.general.communicationMaterials.searchEngine.deactivated")
        )}
      </Group>
    </Stack>
  )
}
